import React, { useEffect, useState } from 'react';
import { ProductData } from 'utils/types';
import { SubRollingOfferMainProduct } from './MainProduct';
import { SubRollingOfferSubProduct } from './SubProduct';
import { StyledSubProductsContainer } from './style';

export interface ProductsData {
  products: ProductData[];
  index: number;
  salePercentage: number;
  isHorizontalViewActive: boolean;
}
const MAX_PRODUCTS = 4;

export const SubRollingOfferProducts: React.FC<ProductsData> = ({
  products,
  index,
  salePercentage = 0,
  isHorizontalViewActive,
}) => {
  const [subProducts, setSubProducts] = useState<ProductData[]>([]);
  const [mainProduct, setMainProduct] = useState<ProductData | null>();

  useEffect(() => {
    if (products.length === 1) {
      setMainProduct(products[0]);
      setSubProducts([]);
    } else if (products.length > 1) {
      setSubProducts(products);
      setMainProduct(null);
    }
  }, [products]);

  return (
    <>
      {mainProduct && (
        <SubRollingOfferMainProduct
          quantityDisplay={mainProduct.quantityDisplay}
          publisherProductId={mainProduct.publisherProductId}
          images={mainProduct.images}
          quantity={mainProduct.quantity}
          strokedSaleQuantity={mainProduct.strokedSaleQuantity}
          salePercentage={salePercentage}
          textFontColorHex={mainProduct.textFontColorHex}
          isHorizontalViewActive={isHorizontalViewActive}
        />
      )}
      {subProducts && subProducts.length > 0 && (
        <StyledSubProductsContainer
          className="sub-products-container"
          isHorizontalViewEnabled={isHorizontalViewActive}
        >
          {subProducts
            .slice(0, MAX_PRODUCTS)
            .map((subProduct: ProductData, productIndex: number) => (
              <SubRollingOfferSubProduct
                subProduct={subProduct}
                key={`${subProduct.publisherProductId}${index}${productIndex}`}
                index={productIndex}
                isHorizontalViewActive={isHorizontalViewActive}
              />
            ))}
        </StyledSubProductsContainer>
      )}
    </>
  );
};
